/* ============================================================
   NORTHSHEEP — Expected delivery date (shared helper)
   Single source of truth for the estimated-delivery calculation used
   by BOTH the product page and the cart (drawer + cart page).

   Rules:
     • Mon–Fri are working days; Sat & Sun are never shipping/transit days.
     • A cut-off time (wall-clock in a configurable timezone, default
       12:00 Europe/Amsterdam) decides whether *today* still dispatches.
     • If it's the weekend OR we're past the cut-off, dispatch slips to the
       next working day — i.e. the whole estimate moves forward exactly one
       working day. Transit days (min/max) are then counted ON TOP of the
       dispatch day, weekends skipped.

   Because business-day addition composes, "slip a working day" is simply
   "add 1 to min and max" — that's the entire trick.

   window.NsDelivery.computeRange({ min, max, cutoff:'12:00', tz:'Europe/Amsterdam' })
     -> { start: Date, end: Date, shipToday: Boolean }
   ============================================================ */
(function () {
  if (window.NsDelivery) return;

  function isWeekend(d) { var w = d.getDay(); return w === 0 || w === 6; }

  // Count n working days forward from `from` (Sat/Sun skipped).
  function addBusinessDays(from, n) {
    var d = new Date(from.getFullYear(), from.getMonth(), from.getDate());
    var added = 0;
    while (added < n) {
      d.setDate(d.getDate() + 1);
      if (!isWeekend(d)) added++;
    }
    return d;
  }

  // Today's calendar date + minutes-since-midnight, evaluated in `tz`
  // (so "past the cut-off" is judged in Amsterdam time, not the visitor's).
  function nowInZone(tz) {
    var now = new Date();
    try {
      var parts = new Intl.DateTimeFormat('en-GB', {
        timeZone: tz, year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', hour12: false
      }).formatToParts(now);
      var m = {};
      for (var i = 0; i < parts.length; i++) m[parts[i].type] = parts[i].value;
      var hh = parseInt(m.hour, 10) % 24;
      // Build the date at LOCAL midnight for that calendar day so day-of-week
      // and formatting stay stable regardless of the browser's own timezone.
      var date = new Date(parseInt(m.year, 10), parseInt(m.month, 10) - 1, parseInt(m.day, 10));
      return { date: date, minutes: hh * 60 + parseInt(m.minute, 10) };
    } catch (e) {
      return { date: new Date(now.getFullYear(), now.getMonth(), now.getDate()), minutes: now.getHours() * 60 + now.getMinutes() };
    }
  }

  // "HH:MM" -> minutes since midnight, or null when blank/invalid (= no cut-off).
  function parseCutoff(str) {
    if (str == null) return null;
    var m = String(str).trim().match(/^(\d{1,2}):(\d{2})$/);
    if (!m) return null;
    var h = +m[1], mi = +m[2];
    if (h > 23 || mi > 59) return null;
    return h * 60 + mi;
  }

  function computeRange(opts) {
    opts = opts || {};
    var tz = opts.tz || 'Europe/Amsterdam';
    var min = parseInt(opts.min, 10); if (isNaN(min)) min = 1;
    var max = parseInt(opts.max, 10); if (isNaN(max)) max = min;
    if (max < min) max = min;
    var cutoff = (opts.cutoffMinutes != null) ? opts.cutoffMinutes : parseCutoff(opts.cutoff);
    var n = nowInZone(tz);
    var shipToday = !isWeekend(n.date) && (cutoff == null || n.minutes < cutoff);
    var offset = shipToday ? 0 : 1; // slip one working day if closed / past cut-off
    return {
      start: addBusinessDays(n.date, min + offset),
      end: addBusinessDays(n.date, max + offset),
      shipToday: shipToday
    };
  }

  function fmt(date, locale) {
    var opts = { weekday: 'long', day: 'numeric', month: 'long' };
    try { return date.toLocaleDateString(locale || undefined, opts); }
    catch (e) { return date.toLocaleDateString(undefined, opts); }
  }

  function part(date, locale, opts) {
    try { return date.toLocaleDateString(locale || undefined, opts); }
    catch (e) { return date.toLocaleDateString(undefined, opts); }
  }

  /* "Thu 1 – Fri 2 October" (owner, 2026-09-28: add short day names).

     Short weekday + day number, then the month once; twice only when the
     window crosses a month. The day names show when a weekend sits inside
     the window, so "Thu 1 – Mon 5" does not read as a whole week.

     Day BEFORE month, always: this is a European store. Plain "en" is mapped
     to en-GB, because a browser's bare "en" resolves to US ordering ("1 Thu",
     "October 1"). The other languages keep their own conventions:
     de "Do., 1. – Fr., 2. Oktober", nl "do 1 – vr 2 oktober",
     fr "jeu. 1 – ven. 2 octobre". */
  function fmtRange(start, end, locale) {
    var loc = (!locale || /^en/i.test(locale)) ? 'en-GB' : locale;
    var wdDay = { weekday: 'short', day: 'numeric' };
    var month = { month: 'long' };

    if (!end || start.getTime() === end.getTime()) {
      return part(start, loc, wdDay) + ' ' + part(start, loc, month);
    }

    var sameMonth = start.getFullYear() === end.getFullYear() && start.getMonth() === end.getMonth();
    if (sameMonth) {
      return part(start, loc, wdDay) + ' – ' + part(end, loc, wdDay) + ' ' + part(start, loc, month);
    }
    return part(start, loc, wdDay) + ' ' + part(start, loc, month) +
      ' – ' + part(end, loc, wdDay) + ' ' + part(end, loc, month);
  }

  window.NsDelivery = {
    computeRange: computeRange,
    fmt: fmt,
    fmtRange: fmtRange,
    parseCutoff: parseCutoff,
    addBusinessDays: addBusinessDays
  };
})();
